document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.multicolumn--mobile-slider');
  sections.forEach(section => {
    const slider = section.querySelector('.multicolumn-list');
    const slides = section.querySelectorAll('.slider__slide');
    const dotsContainer = section.querySelector('.multicolumn-dots');

    if (!slider || !slides.length || !dotsContainer) return;

    // Clear dots
    dotsContainer.innerHTML = '';

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'multicolumn-dot';
      if (i === 0) dot.classList.add('active');
      dot.type = 'button';

      dot.addEventListener('click', () => {
        const slideStyle = getComputedStyle(slides[0]);
        const marginRight = parseInt(slideStyle.marginRight) || 0;
        const slideWidth = slides[0].offsetWidth + marginRight;
        slider.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
      });

      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll('.multicolumn-dot');

    slider.addEventListener('scroll', () => {
    let index = 0;

    slides.forEach((slide, i) => {
        const slideLeft = slide.offsetLeft;
        if (slider.scrollLeft + slider.offsetWidth / 2 >= slideLeft) {
        index = i;
        }
    });

    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
    });

  });
});
